import { Link } from 'react-router-dom';
import { Container, Row, Col, Image, ListGroup, Card, Button } from 'react-bootstrap';

import data from '../data';

function HomeScreen() {
     return (
          // <Container>
          //      <Row>
          //           <Col>1 of 2</Col>
          //           <Col>2 of 2</Col>
          //      </Row>
          //      <Row>
          //           <Col>1 of 3</Col>
          //           <Col>2 of 3</Col>
          //           <Col>3 of 3</Col>
          //      </Row>
          //      <Button className="btn btn-success"> Button</Button>
          // </Container>
          // );

          <Container>
               <Row>
                    {data.employees.map((employee) => {
                         return (
                              <Col>
                                   <Card>
                                        <Card.Body>
                                             <Card.Title>
                                                  <Link to={`/employee/${employee.slug}`}>
                                                       <p>{employee.name}</p>
                                                  </Link>
                                             </Card.Title>
                                        </Card.Body>
                                        {/* ok` */}
                                   </Card>
                              </Col>
                         );
                    })}
               </Row>
          </Container>
     );
}

export default HomeScreen;
